
import { ParallaxEffect, ParallaxContext } from '@/render/parallax/ParallaxEffect';
import { BaseParallaxEffect } from '@/render/parallax/BaseParallaxEffect';

export class BrutalistBlocksEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config } = pc;
         const size = (200 + layerIndex * 100) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, size );
        const scale = config.parallaxScale || 1.0;

        ctx.fillStyle = pc.color;
        ctx.strokeStyle = pc.color;

        const draw = () => {
            for (let x = x1; x <= x2; x += size) {
                for (let y = y1; y <= y2; y += size) {
                    const w = size * 0.7 * scale * (0.5 + this.pseudoRandom(x) * 0.5);
                    const h = size * 0.7 * scale * (0.5 + this.pseudoRandom(y) * 0.5);
                    
                    if (this.pseudoRandom(x + y) > 0.5) {
                        ctx.fillRect(x, y, w, h);
                    } else {
                        ctx.lineWidth = 4 * scale;
                        ctx.strokeRect(x, y, w, h);
                    }
                }
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
